export { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
export const EMPTY_LABEL = '—';
export const ENRICHMENT_DATA_TEST_UPGRADE_SOURCE = 'enrichment-data-test';
export const MODAL_MIN_BLOCK_SIZE = '14rem';
export const MODAL_WIDTH = '34rem';
export const MAX_INLINE_SIZE = '55ch';
export const ILLUSTRATION_SIZE = '120px';
export const FILL_EMPTY_ONLY_OPTION_VAL = 'smart-fill-option-fill-empty-only';
export const OVERWRITE_EXISTING_OPTION_VAL = 'smart-fill-option-overwrite-existing';